

export default annotateAst;
/*
	This module traverse a module's AST, attaching scope information
	to nodes as it goes, which is later used to determine which
	identifiers need to be rewritten to avoid collisions
*/

import walk from './walk';
import { getName } from '../mappers';

function Scope(options) {
	options = options || {};

	this.parent = options.parent;
	this.names = options.params || [];
}

Scope.prototype = {
	add: function (name) {
		if (! ~this.names.indexOf(name)) // redeclaration of existing binding
			this.names.push(name);
	},

	contains: function (name, ignoreTopLevel) {
		if (ignoreTopLevel && !this.parent) {
			return false;
		}

		if (~this.names.indexOf(name)) {
			return true;
		}

		if (this.parent) {
			return this.parent.contains(name, ignoreTopLevel);
		}

		return false;
	}
};
function annotateAst(ast, options) {
	var trackAssignments = options && options.trackAssignments;

	var scope = new Scope();
	var blockScope = new Scope();
	var declared = {};
	var topLevelFunctionNames = [];
	var templateLiteralRanges = [];

	var envDepth = 0;

	walk(ast, {
		enter: function (node) {
			if (node.type === 'ImportDeclaration' || node.type === 'ExportSpecifier') {
				node._skip = true;
			}

			if (node._skip) {
				return this.skip();
			}

			switch (node.type) {
				case 'FunctionExpression':
				case 'FunctionDeclaration':

					envDepth += 1;

				// fallthrough

				case 'ArrowFunctionExpression':
					if (node.id) {
						addToScope(node);

						// If this is the root scope, this may need to be
						// exported early, so we make a note of it
						if (!scope.parent && node.type === 'FunctionDeclaration') {
							topLevelFunctionNames.push(node.id.name);
						}
					}

					var names = node.params.map(getName);

					names.forEach(function (name) {
						return declared[name] = true;
					});

					scope = node._scope = new Scope({
						parent: scope,
						params: names // TODO rest params?
					});

					break;

				case 'BlockStatement':
					blockScope = node._blockScope = new Scope({
						parent: blockScope
					});

					break;

				case 'VariableDeclaration':
					node.declarations.forEach(node.kind === 'let' ? addToBlockScope : addToScope);
					break;

				case 'ClassExpression':
				case 'ClassDeclaration':
					addToScope(node);
					break;

				case 'MemberExpression':
					!node.computed && (node.property._skip = true);
					break;

				case 'Property':
					node.key._skip = true;
					break;

				case 'TemplateLiteral':
					templateLiteralRanges.push([node.start, node.end]);
					break;

				case 'ThisExpression':
					if (envDepth === 0) {
						node._topLevel = true;
					}
					break;

				case 'AssignmentExpression':
					assignTo(node.left);
					break;

				case 'UpdateExpression':
					assignTo(node.argument);
					break;
			}
		},
		leave: function (node) {
			switch (node.type) {
				case 'FunctionExpression':
				case 'FunctionDeclaration':

					envDepth -= 1;

				// fallthrough

				case 'ArrowFunctionExpression':

					scope = scope.parent;

					break;

				case 'BlockStatement':
					blockScope = blockScope.parent;
					break;
			}
		}
	});

	function assignTo(node) {
		if (trackAssignments && node.type === 'Identifier' && node.name === trackAssignments.name) {
			// This is possibly somewhat hacky. Open to alternative approaches...
			// It will yield false positives if `foo` in `export default foo` is shadowed
			(trackAssignments._assignments || (trackAssignments._assignments = [])).push({
				scope: scope,
				node: node
			});
		}
	}

	function addToScope(declarator) {
		var name = declarator.id.name;

		scope.add(name);
		declared[name] = true;
	}

	function addToBlockScope(declarator) {
		var name = declarator.id.name;

		blockScope.add(name);
		declared[name] = true;
	}

	ast._scope = scope;
	ast._blockScope = blockScope;
	ast._topLevelNames = ast._scope.names.concat(ast._blockScope.names);
	ast._topLevelFunctionNames = topLevelFunctionNames;
	ast._declared = declared;
	ast._templateLiteralRanges = templateLiteralRanges;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/ast/annotate.js.01-babel.map